import * as Types from '../../types';

import { gql } from '@apollo/client';
import { EntityDisplayFragmentDoc } from '../../components/EntityDisplay/EntityDisplay.generated';
import { AddressRiskIndicatorFragmentDoc } from '../../components/RiskIndicator/RiskIndicator.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAddressQueryVariables = Types.Exact<{
  address: Types.Scalars['String']['input'];
}>;

export type GetAddressQuery = {
  __typename?: 'Query';
  address: {
    __typename?: 'Address';
    address: string;
    entity?: {
      __typename?: 'Entity';
      id: any;
      name: string;
      risks: {
        __typename?: 'EntityRiskConnection';
        totalCount: number;
        pageInfo: {
          __typename?: 'PageInfo';
          hasNextPage: boolean;
          hasPreviousPage: boolean;
          startCursor?: string | null;
          endCursor?: string | null;
        };
        edges: Array<{
          __typename?: 'EntityRiskEdge';
          node: {
            __typename?: 'EntityRisk';
            id: any;
            riskType: string;
            severity: string;
            description?: string | null;
          };
        }>;
      };
    } | null;
    risks: {
      __typename?: 'AddressRiskConnection';
      totalCount: number;
      pageInfo: {
        __typename?: 'PageInfo';
        hasNextPage: boolean;
        hasPreviousPage: boolean;
        startCursor?: string | null;
        endCursor?: string | null;
      };
      edges: Array<{
        __typename?: 'AddressRiskEdge';
        node: {
          __typename?: 'AddressRisk';
          id: any;
          riskType: string;
          severity: string;
          description?: string | null;
        };
      }>;
    };
    lists: {
      __typename?: 'ListConnection';
      totalCount: number;
      edges: Array<{
        __typename?: 'ListEdge';
        node: {
          __typename?: 'List';
          id: any;
          name: string;
          description?: string | null;
          status: Types.ListStatus;
          createdAt: any;
        };
      }>;
    };
  };
};

export const GetAddressDocument = gql`
  query GetAddress($address: String!) {
    address(address: $address) {
      address
      entity {
        ...EntityDisplay
      }
      risks {
        ...AddressRiskIndicator
      }
      lists {
        totalCount
        edges {
          node {
            id
            name
            description
            status
            createdAt
          }
        }
      }
    }
  }
  ${EntityDisplayFragmentDoc}
  ${AddressRiskIndicatorFragmentDoc}
`;

/**
 * __useGetAddressQuery__
 *
 * To run a query within a React component, call `useGetAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddressQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useGetAddressQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAddressQuery,
    GetAddressQueryVariables
  > &
    (
      | { variables: GetAddressQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAddressQuery, GetAddressQueryVariables>(
    GetAddressDocument,
    options,
  );
}
export function useGetAddressLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAddressQuery,
    GetAddressQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAddressQuery, GetAddressQueryVariables>(
    GetAddressDocument,
    options,
  );
}
export function useGetAddressSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAddressQuery,
        GetAddressQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetAddressQuery, GetAddressQueryVariables>(
    GetAddressDocument,
    options,
  );
}
export type GetAddressQueryHookResult = ReturnType<typeof useGetAddressQuery>;
export type GetAddressLazyQueryHookResult = ReturnType<
  typeof useGetAddressLazyQuery
>;
export type GetAddressSuspenseQueryHookResult = ReturnType<
  typeof useGetAddressSuspenseQuery
>;
export type GetAddressQueryResult = Apollo.QueryResult<
  GetAddressQuery,
  GetAddressQueryVariables
>;
